import styled from 'styled-components/macro';

import { defaultFocusStyles, transition } from 'theme/themeConstants';

const LinkButton = styled.button`
  color: ${(props) =>
    props.highlighted ? props.theme.colors.primary : props.theme.colors.text.tertiary};
  transition: color ${transition.default};

  :hover {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primary};
  }

  &:focus {
    ${defaultFocusStyles}
  }
`;

export default LinkButton;
